import { render, staticRenderFns } from "./editMenu.vue?vue&type=template&id=6e55b156&scoped=true&"
import script from "./editMenu.vue?vue&type=script&lang=js&"
export * from "./editMenu.vue?vue&type=script&lang=js&"
import style0 from "./editMenu.vue?vue&type=style&index=0&id=6e55b156&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55b156",
  null
  
)

export default component.exports